module.exports = __webpack_public_path__ + "static/our-team-c1102a9498d3b99da8c7da5a3e41c648.jpg";